const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

/**
 * Completa una entrega de lencería
 */
export const completarEntregaLenceria = async (datosEntrega) => {
  try {
    const response = await fetch(`${API_URL}/entregas-lenceria/completar`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        entrega_id: datosEntrega.entrega_id,
        receptor_nombre: datosEntrega.receptor_nombre,
        observaciones: datosEntrega.observaciones,
        firma: datosEntrega.firma,
        items: datosEntrega.items,
        peso_real: datosEntrega.peso_real,
        fecha_entrega: datosEntrega.fecha_entrega,
        ubicacion: datosEntrega.ubicacion,
      }),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Error al completar entrega de lencería');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en completarEntregaLenceria:', error);
    throw error;
  }
};

/**
 * Completa una entrega de lencería vertical
 */
export const completarEntregaLenceriaVertical = async (datosEntrega) => {
  try {
    const response = await fetch(`${API_URL}/entregas-lenceria-vertical/completar/${datosEntrega.entrega_id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        receptor_nombre: datosEntrega.receptor_nombre,
        observaciones: datosEntrega.observaciones,
        firma: datosEntrega.firma,
        items: datosEntrega.items,
        peso_real: datosEntrega.peso_real,
        ubicacion_entrega: datosEntrega.ubicacion,
      }),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Error al completar entrega de lencería vertical');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en completarEntregaLenceriaVertical:', error);
    throw error;
  }
};

/**
 * Completa una entrega de insumos
 */
export const completarEntregaInsumos = async (datosEntrega) => {
  try {
    const response = await fetch(`${API_URL}/entregas-insumos/completar`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        entrega_id: datosEntrega.entrega_id,
        receptor_nombre: datosEntrega.receptor_nombre,
        observaciones: datosEntrega.observaciones,
        firma: datosEntrega.firma,
        items: datosEntrega.items,
        peso_real: datosEntrega.peso_real,
        fecha_entrega: datosEntrega.fecha_entrega,
        ubicacion: datosEntrega.ubicacion,
      }),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Error al completar entrega de insumos');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en completarEntregaInsumos:', error);
    throw error;
  }
};

/**
 * Completa una entrega (detecta automáticamente el tipo y logística)
 */
export const completarEntrega = async (datosEntrega) => {
  const tipo = datosEntrega.tipo;
  const logistica = datosEntrega.logistica;
  
  if (tipo === 'lenceria' && logistica === 'vertical') {
    return await completarEntregaLenceriaVertical(datosEntrega);
  } else if (tipo === 'lenceria') {
    return await completarEntregaLenceria(datosEntrega);
  } else if (tipo === 'insumos') {
    return await completarEntregaInsumos(datosEntrega);
  } else {
    throw new Error('Tipo de entrega no válido');
  }
};
